import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { LIFECYCLE_STEP_KEYS } from './lifecycle';

interface PhoneStepBarProps {
  /** Index of the current lifecycle step (0 Build, 1 Activate, 2 Run). */
  step: number;
  /** Muted note on the right, e.g. how many checks are left. */
  note?: React.ReactNode;
}

/** The phone's lifecycle strip: "1/3 · Yig'ish", three short segments and a note. */
export function PhoneStepBar({ step, note }: PhoneStepBarProps) {
  const { t } = useTranslation();
  return (
    <div className="flex h-11 shrink-0 items-center gap-2.5 border-b border-border bg-card px-4 text-[13px]">
      <span className="shrink-0 font-semibold tabular-nums text-foreground">
        {step + 1}/{LIFECYCLE_STEP_KEYS.length} · {t(LIFECYCLE_STEP_KEYS[step])}
      </span>
      <span aria-hidden className="flex shrink-0 gap-1">
        {LIFECYCLE_STEP_KEYS.map((key, i) => (
          <span key={key} className={cn('h-1 w-[22px] rounded-full', i <= step ? 'bg-foreground' : 'bg-border')} />
        ))}
      </span>
      {note != null && <span className="ml-auto truncate text-muted-foreground">{note}</span>}
    </div>
  );
}

export default PhoneStepBar;
